module.exports = __webpack_public_path__ + "img/cn.fe43ae1a.png";